export const environment = {
  production: false,
  apihost: 'https://mein.dev.zero-test.net',
  apihost_fallback: 'https://mein.t5.zero-test.net' as string | null,
  push_url: 'gbtest.eu.diffusion.cloud',
  push_url_fallback: 't5zerotest.eu.diffusion.cloud' as string | null,
  push_port: 443,
  snowplow: {
    trackerName: 'tn_zero',
    appId: 'zero_web_dev',
    appIdMobile: 'zero_app_dev',
    endpoint: 'https://net-finanzen-dev1.mini.snplow.net',
    postPath: '/com.snowplowanalytics.snowplow/tp2',
    cookieName: '_snowplow',
    networkSites: [
      'localhost:4200',
      'ecs-alb-2139076639.eu-central-1.elb.amazonaws.com',
      'ai.dev.zero-test.net',
      'zeroai.finanzen-zero.net',
      'finanzen.net',
      'www.finanzen.net',
      'g.finanzen.net',
      'finanzen-zero.net',
      'www.finanzen-zero.net',
      'mein.finanzen-zero.net',
    ],
  },
  snowplowPortal: {
    trackerName: 'tn_portal',
    appId: 'net_web_dev',
    appIdMobile: 'net_web_dev',
    endpoint: 'https://net-finanzen-dev1.mini.snplow.net',
    postPath: '/com.snowplowanalytics.snowplow/tp2',
    cookieName: '_snowplow',
    networkSites: [
      'localhost:4200',
      'ecs-alb-2139076639.eu-central-1.elb.amazonaws.com',
      'ai.dev.zero-test.net',
      'zeroai.finanzen-zero.net',
      'finanzen.net',
      'www.finanzen.net',
      'g.finanzen.net',
      'finanzen-zero.net',
      'www.finanzen-zero.net',
      'mein.finanzen-zero.net',
    ],
  },
  unleash: {
    url: 'https://features.dev.zero-test.net/api/frontend',
    accessToken: 'zero:zero_dev.b0d838eea4d73acc138d8b72cb1129d726d3f8910b7406c3e97e250f',
    appName: 'zero-web',
    refreshInterval: 15, // seconds
  },
};
